<template>
    <div>
        <auth-state></auth-state>
        <b-row>
            <b-col md="8">
                <auth-notice></auth-notice>
                <login-history></login-history>
            </b-col>
            <b-col md="4">
                <auth-user-info></auth-user-info>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import AuthState from '@/components/Home/AuthState.vue'
import AuthNotice from '@/components/Home/AuthNotice.vue'
import AuthUserInfo from '@/components/Home/AuthUserInfo.vue'
import LoginHistory from '@/components/Home/LoginHistory.vue'
export default {
    components: {
        AuthState,
        AuthNotice,
        AuthUserInfo,
        LoginHistory
    }
}
</script>

<style>
</style>
